import { CSSObject } from 'styled-components'
import { Theme } from '@/src/ct-design/token/theme'
import {
    ProcessFlowSize,
    ProcessFlowStatus,
    ProcessFlowDirection
} from './types'

export type ProcessFlowCircleStyleProps = {
    theme: Theme
    status?: ProcessFlowStatus
    size?: ProcessFlowSize
    color?: string
}

export type ProcessFlowDividerStyleProps = {
    theme: Theme
    status?: ProcessFlowStatus
    direction?: ProcessFlowDirection
    size?: ProcessFlowSize
    color?: string
}

/**
 * Get styles for the ProcessFlow circle component
 */
export const getProcessFlowCircleStyles = ({
    theme,
    status = 'UPCOMING',
    size = 'md',
    color
}: ProcessFlowCircleStyleProps): CSSObject => {
    const isCompleted = status === 'COMPLETED'
    const isCurrent = status === 'CURRENT'
    const borderWidth = size === 'md' ? '8px' : '6px'

    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: size === 'md' ? '24px' : '20px',
        minWidth: size === 'md' ? '24px' : '20px',
        maxHeight: size === 'md' ? '24px' : '20px',
        maxWidth: size === 'md' ? '24px' : '20px',
        borderRadius: '50%',
        border: `solid ${borderWidth} ${
            color
                ? color
                : isCompleted
                  ? theme?.color?.background?.primary
                  : isCurrent
                    ? theme?.color?.border?.primary
                    : theme?.color?.border?.default
        }`,
        color: isCompleted ? 'white' : 'inherit',
        fontSize: size === 'md' ? '12px' : '10px',
        fontWeight: 500
    }
}

/**
 * Get styles for the ProcessFlow divider component
 */
export const getProcessFlowDividerStyles = ({
    theme,
    status = 'UPCOMING',
    direction = 'vertical',
    size = 'md',
    color
}: ProcessFlowDividerStyleProps): CSSObject => {
    const isCompleted = status === 'COMPLETED'
    const thickness = '3px'

    // Base styles that are the same for both directions
    const baseStyles = {
        backgroundColor: color
            ? color
            : isCompleted
              ? theme?.color?.background?.primary
              : theme?.color?.border?.default,
        borderRadius: '10px'
    }

    if (direction === 'vertical') {
        return {
            ...baseStyles,
            width: thickness,
            height: '100%',
            marginTop: '6px',
            marginBottom: '-2px',
            marginLeft: 'auto',
            marginRight: 'auto',
            minHeight: '40px'
        }
    } else {
        return {
            ...baseStyles,
            height: thickness,
            marginTop: '10px',
            position: 'absolute',
            left: '54px',
            right: 0
        }
    }
}
